export default __webpack_public_path__ + "static/media/wibi.5d7a6a58.png";